import React, { ComponentProps } from 'react';

import propTypes from '@styled-system/prop-types';
import styledC from 'styled-components';
import {
  space,
  SpaceProps,
  color,
  ColorProps,
  layout,
  LayoutProps,
  flexbox,
  FlexboxProps,
  grid,
  GridProps,
  position,
  PositionProps,
  border,
  BorderProps,
  typography as typographySystem,
  TypographyProps,
} from 'styled-system';

import {
  Colors,
  Typography,
  typography,
  propTypes as themePropTypes,
  base,
  ellipsis,
  Ellipsis,
} from './Theme';

export const boxPropTypes = {
  ...propTypes.border,
  ...propTypes.space,
  ...propTypes.layout,
  ...propTypes.typography,
  ...propTypes.flexbox,
  ...propTypes.color,
  ...propTypes.grid,
  ...themePropTypes.color,
  ...themePropTypes.typography,
  ...themePropTypes.ellipsis,
};

export interface IBoxProps
  extends SpaceProps,
    PositionProps,
    LayoutProps,
    BorderProps,
    TypographyProps,
    FlexboxProps,
    GridProps,
    ColorProps,
    ComponentProps<'div'> {
  typography?: Typography;
  color?: Colors;
  bg?: Colors;
  ellipsis?: Ellipsis;
}

const Box: React.FC<IBoxProps> = styledC.div<IBoxProps>(
  base,
  space,
  layout,
  border,
  flexbox,
  color,
  grid,
  typography,
  position,
  ellipsis,
  typographySystem,
);

Box.displayName = 'Box';
Box.propTypes = boxPropTypes;

export default Box;
